export default __webpack_public_path__ + "static/media/user-06.ffd091ac.jpg";